  class ApplicationDataApp {

    public clientData: any = {};
    public userInfo: Object = {};

    public setClientData(client: any){
        this.clientData = client;
    }

    public getClientData(){
        return this.clientData;
    }

    public getSlugClient() {
        return this.clientData.slug;
    }

    public getUserInfo(){
        return this.userInfo;
    }
}

const ApplicationData = new ApplicationDataApp();
export default ApplicationData;